/**
 * Helper para banderas de ambiente y funcionalidades (Feature Flags)
 */

export const IS_DEV_ENV = (() => {
  const env = import.meta.env.VITE_APP_ENV;
  if (env) {
    return env.toLowerCase() === "development" || env.toLowerCase() === "dev";
  }
  return Boolean(import.meta.env.DEV);
})();

/**
 * Flag para habilitar/deshabilitar la pasarela Nequi.
 * Si VITE_ENABLE_NEQUI está definida en .env ("true" / "false"), se respeta ese valor.
 * De lo contrario, se habilita por defecto sólo en ambiente de desarrollo.
 */
export const IS_NEQUI_ENABLED = (() => {
  const val = import.meta.env.VITE_ENABLE_NEQUI;
  if (val !== undefined && val !== "") {
    return String(val).toLowerCase() === "true";
  }
  return IS_DEV_ENV;
})();

/**
 * Flag para habilitar/deshabilitar la recarga de créditos (botón y modal).
 * Si VITE_ENABLE_CREDIT_RECHARGE está definida en .env ("true" / "false"), se respeta ese valor.
 * De lo contrario, se habilita por defecto sólo en ambiente de desarrollo.
 */
export const IS_CREDIT_RECHARGE_ENABLED = (() => {
  const val = import.meta.env.VITE_ENABLE_CREDIT_RECHARGE;
  if (val !== undefined && val !== "") {
    return String(val).toLowerCase() === "true";
  }
  return IS_DEV_ENV;
})();
